<template>
  <t-card v-loading="showFlag">
    <t-form
      ref="customerInfoFormData"
      :model="customerInfoFormData"
      domain="customerInfoFormData"
      label-position="right"
      label-width="110px"
      class="customerInfoForm"
    >
      <t-row>
        <!-- 得意先コード -->
        <t-col :span="12">
          <t-form-item
            :label="$t('resource.customerInfo.cusCode')"
            prop="cusCode"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-input
              v-model="customerInfoFormData.cusCode"
              :disabled="disabled"
              maxLength="3"
              clearable
              @change="changeData"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- 得意先名 -->
          <t-form-item
            :label="$t('resource.customerInfo.cusName')"
            prop="cusName"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-input
              v-model="customerInfoFormData.cusName"
              maxLength="40"
              clearable
            ></t-input> </t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- 得意先略称 -->
          <t-form-item
            prop="cusAbbreviation"
            :label="$t('resource.customerInfo.abbreviation')"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-input
              v-model="customerInfoFormData.cusAbbreviation"
              maxLength="15"
              clearable
            ></t-input></t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- アドレス -->
          <t-form-item
            :label="$t('resource.customerInfo.cusAddress')"
            prop="cusAdd"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-input
              v-model="customerInfoFormData.cusAdd"
              maxLength="100"
              clearable
            ></t-input></t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- TEL -->
          <t-form-item
            :label="$t('resource.customerInfo.cusTel')"
            prop="cusTel"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-input
              v-model="customerInfoFormData.cusTel"
              maxLength="15"
              clearable
            ></t-input></t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- FAX -->
          <t-form-item
            :label="$t('resource.customerInfo.cusFax')"
            prop="cusFax"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-input
              v-model="customerInfoFormData.cusFax"
              maxLength="20"
              clearable
            ></t-input> </t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- 郵便番号 -->
          <t-form-item
            :label="$t('resource.customerInfo.cusZipCode')"
            prop="cusZipCode"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-input
              v-model="customerInfoFormData.cusZipCode"
              maxLength="15"
              clearable
            ></t-input> </t-form-item
        ></t-col>
      </t-row>

      <t-row>
        <t-col :span="12">
          <!-- 締め日 -->
          <t-form-item
            :label="$t('resource.customerInfo.cusCalculateDate')"
            prop="cusCalculateDate"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-input
              v-model="customerInfoFormData.cusCalculateDate"
              maxLength="2"
              clearable
            ></t-input>
          </t-form-item>
        </t-col>

        <t-col :span="12">
          <!-- 終了日 -->
          <t-form-item
            :label="$t('resource.supplierInfo.endDate')"
            prop="cusEndDate"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-date-picker
              v-model="customerInfoFormData.cusEndDate"
              type="date"
              :placeholder="$t('resource.sys.hidden')"
              value-format="yyyy/MM/dd"
              style="width: 100%"
              format="yyyy/MM/dd"
              :clearable="false"
              :editable="false"
            ></t-date-picker>
          </t-form-item>
        </t-col>
      </t-row>
      <t-row v-if="!this.isAddFlg">
        <!-- 担当者 -->
        <t-col :span="24">
          <t-form-item
            :label="$t('resource.customerInfo.manager')"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-table
              ref="managerList"
              :data="managerList"
              class="table_common"
              :height="detailHeight"
              header-cell-class-name="bg-default"
              border
            >
              <t-table-column
                v-for="(column, index) in columns"
                :key="index"
                :type="column.type"
                :prop="column.prop"
                :label="column.label"
                :min-width="column.width"
                :class-name="column.class"
                :show-overflow-tooltip="column.overflowTooltip"
              >
                <template slot-scope="scope">
                  <t-checkbox
                    v-if="column.prop == 'mgrDelFlag'"
                    v-model="scope.row[column.prop]"
                    true-label="1"
                    false-label="0"
                  ></t-checkbox>
                  <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                  <!-- <span v-else-if="column.prop == 'mgrCode'"
                    >{{ scope.row[column.prop] }} -->
                  <!-- </span> -->
                  <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                  <t-input
                    v-else
                    class="editInput"
                    :maxLength="column.maxLength"
                    @change="changeData"
                    v-model="scope.row[column.prop]"
                  />
                </template>
              </t-table-column>
            </t-table>
          </t-form-item>
        </t-col>
      </t-row>

      <!-- ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓ -->
      <t-row v-if="!this.isAddFlg">
        <!-- 納品先の追加 -->
        <t-col :span="24">
          <t-form-item
            :label="$t('resource.customerInfo.DELI_ADDR')"
            :class="{ marginBottom: !isAddFlg }"
          >
            <t-table
              ref="deliveryList"
              :data="deliveryList"
              class="table_common"
              :height="delvDetailHeight"
              header-cell-class-name="bg-default"
              border
            >
              <t-table-column
                v-for="(column, index) in delAddrColumns"
                :key="index"
                :type="column.type"
                :prop="column.prop"
                :label="column.label"
                :min-width="column.width"
                :class-name="column.class"
                :show-overflow-tooltip="column.overflowTooltip"
              >
                <template slot-scope="scope">
                  <t-checkbox
                    v-if="column.prop == 'damDelFlag'"
                    v-model="scope.row[column.prop]"
                    true-label="1"
                    false-label="0"
                  ></t-checkbox>
                  <span v-else-if="column.prop == 'damCode'"
                    >{{ scope.row[column.prop] }}
                  </span>
                  <t-input
                    v-else
                    class="editInput"
                    :maxLength="column.maxLength"
                    @change="deliveryChangeData"
                    v-model="scope.row[column.prop]"
                  />
                </template>
              </t-table-column>
            </t-table>
          </t-form-item>
        </t-col>
      </t-row>
      <!-- ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑ -->

      <t-row type="flex" justify="end">
        <div>
          <t-col :span="24">
            <!-- 確定  -->
            <t-button
              v-if="isAddFlg"
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              @click="confirm"
            >
              <i class="el-icon-check"></i>
              {{ $t("resource.sys.sure") }}</t-button
            >

            <!-- 变更 -->
            <t-button
              v-else
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              @click="confirm"
            >
              <i class="el-icon-check"></i>
              {{ $t("resource.sys.sure") }}</t-button
            >
          </t-col>
        </div>
      </t-row>
    </t-form>
  </t-card>
</template>
<script>
import { t } from "@/locales";
import {
  AddCusMstInfo,
  ChangeCusMstInfo,
  GetCusMstInfoByCode,
} from "@/services/customerInfo";
import { cmpBasicData, cmpDetailData } from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { Message as MessageA, Modal } from "@tellus/component";
import { Message } from "@tellus/ui";
export default {
  data() {
    return {
      customerInfoForm: {},

      customerInfoFormData: {
        cusCode: "",
        cusName: "",
        cusAbbreviation: "",
        cusAdd: "",
        cusTel: "",
        cusFax: "",
        cusZipCode: "",
        cusCalculateDate: "",
        cusEndDate: "",
      },

      managerInfoFormData: [],

      disabled: false,
      showFlag: false,
      isAddFlg: false,
      //担当得意先
      managerList: [],
      //現在選択されているセル
      currentCell: null,

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // 納品先リスト
      deliveryList: [],
      // 納品先データ
      deliveryFormData: [],
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      isCustomHeight: true,

      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // detailHeight: DIALOG_LINE_HEIGHT * 5,
      detailHeight: DIALOG_LINE_HEIGHT * 5,
      delvDetailHeight: DIALOG_LINE_HEIGHT * 4,
      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      columns: [
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // // 担当者コード(表示しない?)
        // {
        //   prop: "mgrCode",
        //   label: t("resource.customerInfo.mgrCode"),
        //   width: t("widgetSize.tableCommon.width50"),
        //   class: "cell_txt_left",
        //   overflowTooltip: false,
        // },

        // 担当者コード(表示用)
        {
          prop: "mgrCodeShow",
          label: t("resource.customerInfo.mgrCode"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_left",
          maxLength: 6,
          overflowTooltip: false,
        },
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // 担当者名
        {
          prop: "mgrName",
          label: t("resource.customerInfo.mgrName"),
          class: "cell_txt_center",
          width: t("widgetSize.tableCommon.defaultWidth"),
          maxLength: 50,
          overflowTooltip: false,
        },
        // 電話番号
        {
          prop: "mgrTel",
          label: t("resource.customerInfo.mgrTel"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          maxLength: 15,
          overflowTooltip: false,
        },
        //メール
        {
          prop: "mgrMail",
          label: t("resource.customerInfo.mgrMail"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          maxLength: 50,
          overflowTooltip: false,
        },
        //削除
        {
          prop: "mgrDelFlag",
          label: t("resource.customerInfo.mgDelFlag"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
      ],

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // 納品先の追加
      delAddrColumns: [
        // 納品先コード
        {
          prop: "damCode",
          label: t("resource.customerInfo.mgrCode"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // 納品先名
        {
          prop: "damName",
          label: t("resource.customerInfo.mgrName"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          maxLength: 15,
          overflowTooltip: false,
        },
        // 納品先アドレス
        {
          prop: "damAddr",
          label: t("resource.customerInfo.cusAddress"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          maxLength: 50,
          overflowTooltip: false,
        },

        //削除
        {
          prop: "damDelFlag",
          label: t("resource.customerInfo.mgDelFlag"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      ],

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // 比較用明細情報 （納品先）
      cmpDelvDetailResult: {},
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
    };
  },
  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
  },

  created() {
    this.isAddFlg = this.isAdd;
  },

  mounted() {
    if (!this.isAddFlg) {
      this.init(this.rowData.cusCode);
    } else {
      this.customerInfoFormData.cusEndDate = "2099/12/31";

      // 比較用基本情報の初期化
      this.initComparisonInfo();

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      //テーブルの高さを監視する
      window.addEventListener("resize", this.handleResize);
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
    }
  },
  methods: {
    init(cusCode) {
      this.editDialogHigh();

      this.showFlag = true;
      this.disabled = true;
      this.searchClick(cusCode);
    },

    changeData(value) {
      if (value.length != 3 && this.isAddFlg) {
        this.managerInfoFormData = [];
      }

      if (value.length == 3 && this.isAddFlg) {
        this.managerInfoFormData = [];

        //新規行の追加(空行)
        //let nullRowCnt = this.managerList.length == 0 ? 10 : 5;
        let nullRowCnt = 5;

        //担当者の表示
        let mgrCode = 0;

        for (let i = 1; i <= nullRowCnt; i++) {
          this.managerInfoFormData.push({
            //担当者コード
            mgrCode:
              this.customerInfoFormData.cusCode +
              (mgrCode + i).toString().padStart(3, "0"),
            // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
            // 課題_担当者コード表示用の追加
            // 担当者コード表示用
            mgrCodeShow: "",
            // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
            //担当者名
            mgrName: "",
            //電話番号
            mgrTel: "",
            //メール
            mgrMail: "",
            //削除区分
            mgDelFlag: "0",
          });
        }
      }
    },

    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
    deliveryChangeData(value) {
      if (value.length != 3 && this.isAddFlg) {
        this.deliveryFormData = [];
      }

      if (value.length == 3 && this.isAddFlg) {
        this.deliveryFormData = [];

        //新規行の追加(空行)
        //let nullRowCnt = this.managerList.length == 0 ? 10 : 5;
        let nullRowCnt = 5;

        //担当者の表示
        let mgrCode = 0;

        for (let i = 1; i <= nullRowCnt; i++) {
          this.deliveryFormData.push({
            //納品先コード
            damCode:
              this.customerInfoFormData.cusCode +
              (mgrCode + i).toString().padStart(3, "0"),
            //得意先コード
            damCusCode: "",
            //納品先名
            damName: "",
            //アドレス
            damAddr: "",
            //削除区分
            damDelFlag: "0",
          });
        }
      }
    },
    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

    // 編集
    confirm() {
      //担当者のチェックの追加＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
      this.$refs.customerInfoFormData.validate((valid) => {
        if (valid) {
          if (!this.inputCheck()) {
            return;
          }

          this.showFlag = true;

          this.customerInfoFormData.updateUser = localStorage.getItem("userId");
          if (this.isAddFlg) {
            AddCusMstInfo(this.customerInfoFormData, () => {
              this.numLoads = 1;
              this.isAddFlg = false;
              this.init(this.customerInfoFormData.cusCode);
              MessageA.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
            })
              .catch((err) => {
                if (err.data != null) {
                  if (err.data.Messages[0].Id === "cusErr") {
                    Modal.showWarning(
                      "",
                      t(
                        "message.COMMON_MESSAGE." + err.data.Messages[0].Message
                      ),
                      {
                        confirmButtonText: t(
                          "resource.COMMON_CONSTANT.CONFIRM"
                        ),
                      }
                    );
                  } else {
                    Message.showError(
                      t(
                        "message.COMMON_MESSAGE." + err.data.Messages[0].Message
                      )
                    );
                  }
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
                }
              })
              .finally(() => {
                this.showFlag = false;
              });
          } else {
            ChangeCusMstInfo(this.customerInfoFormData, () => {
              this.numLoads = 1;
              this.init(this.customerInfoFormData.cusCode);
              MessageA.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
            })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
                }
              })
              .finally(() => {
                this.showFlag = false;
              });
          }
        }
      });
    },

    editDialogHigh() {
      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // if (!this.isAddFlg) {
      //   const dialog = document.querySelector(
      //     ".el-dialog.specialDialogHeight420"
      //   );
      //   dialog.style.height = "680px";
      // }

      this.$nextTick(() => {
        const dlg = this.$el.closest(".el-dialog");
        if (!dlg) return;

        dlg.classList.remove("specialDialogHeight420", "cusEditDialogHeight");

        dlg.classList.add(
          this.isAddFlg ? "specialDialogHeight420" : "cusEditDialogHeight"
        );
        dlg.style.height = "775px";
      });
      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
    },

    inputCheck() {
      let result = true;
      let continueFlg = true;

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // let lastIndexOfNonEmptyMgrName = this.managerList.findLastIndex(
      //   (item) => item.mgrName !== ""
      // );
      // 文字列の両端の空白文字を除去する
      this.managerList.forEach((element) => {
        if (element.mgrCodeShow)
          element.mgrCodeShow = element.mgrCodeShow.trim();
        if (element.mgrName) element.mgrName = element.mgrName.trim();
        if (element.mgrTel) element.mgrTel = element.mgrTel.trim();
        if (element.mgrMail) element.mgrMail = element.mgrMail.trim();
      });

      let lastIndexOfNonEmptyMgrCodeShow = this.managerList.findLastIndex(
        (item) => item.mgrCodeShow !== ""
      );
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      this.managerList.forEach((item, index) => {
        // 担当者コード表示用が空の場合、エラーメッセージを表示する
        if (
          item &&
          (item.mgrTel !== "" || item.mgrMail !== "" || item.mgrName !== "") &&
          item.mgrCodeShow === ""
        ) {
          Modal.showWarning(
            "",
            "「" + (index + 1) + "」行目のコード" + t("message.input.hint"),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          result = false;
          return;
        }
      });
      if (!result) {
        return result;
      }

      // 重複mgrCodeShowの存在の場合、エラーメッセージを表示する
      const hasDuplicateMgrCodeShow = this.managerList.some(
        (item, index, arr) => {
          return (
            arr.findIndex(
              (item2, index2) =>
                item &&
                (item.mgrTel !== "" ||
                  item.mgrMail !== "" ||
                  item.mgrName !== "") &&
                item2.mgrCodeShow === item.mgrCodeShow &&
                index2 !== index
            ) !== -1
          );
        }
      );

      if (hasDuplicateMgrCodeShow) {
        Modal.showWarning("", "重複しないコードで入力してください", {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return false;
      }

      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      this.managerList.forEach((item, index) => {
        if (continueFlg == false) {
          return;
        }

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // let message =
        //   "コード「" +
        //   item.mgrCode +
        //   "」の" +
        //   t("message.VALIDATION.MGR_NAME_MUST_INPUT");

        let message =
          "コード「" +
          item.mgrCodeShow +
          "」の" +
          t("message.VALIDATION.MGR_NAME_MUST_INPUT");
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        if (item.createTime !== undefined && item.createTime !== "") {
          // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          //担当者コード表示用が空のチェック
          if (item.mgrCodeShow === "") {
            Modal.showWarning(
              "",
              "「" + (index + 1) + "」行目のコード" + t("message.input.hint"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            result = false;
            continueFlg = false;
            return;
          }
          // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

          if (item.mgrName === "") {
            // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
            // Modal.showWarning("", message, {
            //   confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            // });
            Modal.showWarning(
              "",
              "「" +
                (index + 1) +
                "」行目の" +
                t("message.VALIDATION.MGR_NAME_MUST_INPUT"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

            result = false;
            continueFlg = false;
            return;
          }
        } else {
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // if (
          //   lastIndexOfNonEmptyMgrName != -1 &&
          //   index > lastIndexOfNonEmptyMgrName
          // ) {
          //   continueFlg = false;
          //   return;
          // }

          // if (
          //   (item.mgrTel != "" || item.mgrMail != "") &&
          //   item.mgrName === ""
          // ) {

          // 担当者コード表示用が空のindex，保存しない
          if (
            lastIndexOfNonEmptyMgrCodeShow != -1 &&
            index > lastIndexOfNonEmptyMgrCodeShow
          ) {
            continueFlg = false;
            return;
          }

          //電話番号・メール・担当者コード表示用が空しない場合、エラーメッセージを表示する
          if (
            (item.mgrTel != "" ||
              item.mgrMail != "" ||
              item.mgrCodeShow != "") &&
            item.mgrName === ""
          ) {
            // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
            Modal.showWarning("", message, {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });

            result = false;
            continueFlg = false;
            return;
          }

          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // if (lastIndexOfNonEmptyMgrName != -1 && item.mgrName === "") {
          //    Modal.showWarning("", message, {
          //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          //   });

          //   result = false;
          //   continueFlg = false;
          //   return;
          // }
          if (lastIndexOfNonEmptyMgrCodeShow != -1 && item.mgrCodeShow === "") {
            Modal.showWarning(
              "",
              "「" + (index + 1) + "」行目のコード" + t("message.input.hint"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );

            result = false;
            continueFlg = false;
            return;
          }
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        }
      });

      // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 start↓
      // 得意先担当者のチェックの追加
      if (!result) {
        return result;
      }
      // 重複mgrNameの存在の場合、エラーメッセージを表示する
      const hasDuplicateMgrName = this.managerList.some((item, index, arr) => {
        return (
          arr.findIndex(
            (item2, index2) =>
              item &&
              (item.mgrTel !== "" ||
                item.mgrMail !== "" ||
                item.mgrName !== "") &&
              item2.mgrName === item.mgrName &&
              index2 !== index
          ) !== -1
        );
      });

      if (hasDuplicateMgrName) {
        Modal.showWarning("", "重複しない名称で入力してください", {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return false;
      }
      // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 end↑

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      if (result) {
        result = this.delvDataInputCheck();
      }

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      return result;
    },

    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
    delvDataInputCheck() {
      let result = true;
      let continueFlg = true;

      // 納品先：文字列の両端の空白文字を除去する
      this.deliveryList.forEach((element) => {
        if (element.damName) element.damName = element.damName.trim();
        if (element.damAddr) element.damAddr = element.damAddr.trim();
      });

      let lastIndexOfNonEmptyDamName = this.deliveryList.findLastIndex(
        (item) => item.damName !== ""
      );

      if (!result) {
        return result;
      }

      this.deliveryList.forEach((item, index) => {
        if (continueFlg == false) {
          return;
        }

        let message =
          "納品先コード「" +
          item.damCode +
          "」の" +
          t("message.VALIDATION.MGR_NAME_MUST_INPUT");

        if (item.damCreateTime !== undefined && item.damCreateTime !== "") {
          if (item.damName === "") {
            Modal.showWarning("", message, {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });

            result = false;
            continueFlg = false;
            return;
          }
        } else {
          if (
            lastIndexOfNonEmptyDamName != -1 &&
            index > lastIndexOfNonEmptyDamName
          ) {
            continueFlg = false;
            return;
          }

          if (item.damAddr != "" && item.damName === "") {
            continueFlg = false;
            return;
          }

          //納品先名・納品先アドレス用が空しない場合、エラーメッセージを表示する
          if (item.damAddr != "" && item.damName === "") {
            Modal.showWarning("", message, {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });

            result = false;
            continueFlg = false;
            return;
          }

          if (lastIndexOfNonEmptyDamName != -1 && item.damName === "") {
            Modal.showWarning("", message, {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });

            result = false;
            continueFlg = false;
            return;
          }
        }
      });
      return result;
    },
    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

    searchClick(cusCode) {
      GetCusMstInfoByCode(cusCode)
        .then((res) => {
          this.customerInfoFormData = res;

          this.managerList = res.managerInfoList;
          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
          // 納品先リスト
          this.deliveryList = res.delvAddrInfoList;
          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

          //担当者の表示
          let mgrCode = 0;

          if (this.managerList.length > 0) {
            let mgrCodeTmp =
              this.managerList[this.managerList.length - 1].mgrCode;
            mgrCodeTmp = mgrCodeTmp.replace(
              this.customerInfoFormData.cusCode,
              ""
            );
            mgrCode = parseInt(mgrCodeTmp);
          }

          //新規行の追加(空行)
          //let nullRowCnt = this.managerList.length == 0 ? 10 : 5;
          let nullRowCnt = 5;

          for (let i = 1; i <= nullRowCnt; i++) {
            this.managerList.push({
              //担当者コード
              mgrCode:
                this.customerInfoFormData.cusCode +
                (mgrCode + i).toString().padStart(3, "0"),
              // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
              // 課題_担当者コード表示用の追加
              // 担当者コード表示用
              mgrCodeShow: "",
              // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
              //担当者名
              mgrName: "",
              //電話番号
              mgrTel: "",
              //メール
              mgrMail: "",
              //削除区分
              mgDelFlag: "0",
            });
          }
          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓

          //納品先の表示
          let damCode = 0;

          if (this.deliveryList.length > 0) {
            let damCodeTmp =
              this.deliveryList[this.deliveryList.length - 1].damCode;
            damCodeTmp = damCodeTmp.replace(
              this.customerInfoFormData.cusCode,
              ""
            );
            damCode = parseInt(damCodeTmp);
          }

          for (let i = 1; i <= nullRowCnt; i++) {
            this.deliveryList.push({
              //納品先コード
              damCode:
                this.customerInfoFormData.cusCode +
                (damCode + i).toString().padStart(3, "0"),
              //得意先コード
              damCusCode: "",
              //納品先名
              damName: "",
              //アドレス
              damAddr: "",
              //削除区分
              damDelFlag: "0",
            });
          }
          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

          // 比較用基本情報の初期化
          this.initComparisonInfo();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 比較用基本情報の初期化
    initComparisonInfo() {
      // 読み込み回数 = 1
      if (this.numLoads == 1) {
        // 比較用基本情報
        this.cmpBasicResult = JSON.parse(
          JSON.stringify(this.customerInfoFormData)
        );

        // 比較用明細情報
        this.cmpDetailResult = JSON.parse(JSON.stringify(this.managerList));

        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        this.cmpDelvDetailResult = JSON.parse(
          JSON.stringify(this.deliveryList)
        );
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    // ダイアログを閉じる
    onCancel() {
      if (
        !cmpBasicData(this.cmpBasicResult, this.customerInfoFormData) ||
        !cmpDetailData(this.cmpDetailResult, this.managerList) ||
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        !cmpDetailData(this.cmpDelvDetailResult, this.deliveryList)
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }

      // this.$emit("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-height {
  max-height: 800px; /* 或其他你需要的值 */
  overflow-y: auto;
}
</style>
